import React from 'react'
import classNames from 'classnames'
import {EventImage} from '../../event-image'
import s from './mobile-image.scss'
import {MobileImageProps} from './index'

export const MobileImage: React.FC<MobileImageProps> = ({isSquareImage}) => (
  <EventImage className={classNames(s.container, isSquareImage ? s.square : s.wide)} />
)
